import Cookies from "js-cookie";
import { useEffect } from "react";

export function useUpdatePersonalization(
  terms: { value: { codename: string }[] } | undefined
) {
  useEffect(() => {
    if (terms?.value.length) {
      terms.value.forEach((term) => {
        const cookieKey = `ep_${term.codename}`;
        let increment = 1;
        const current = parseInt(Cookies.get(cookieKey) as string);

        if (!isNaN(current)) {
          increment += current;
        }

        Cookies.set(cookieKey, increment.toString(), {
          expires: 90,
          secure: true,
        });
      });
    }
  }, [terms]);
}
